module.exports = __webpack_public_path__ + "static/media/generatorSound.365c6b5b.mp3";